export default {
  label: 'Opkræv servicegebyr på bordbestillinger',
  description: 'Bordbestillinger betaler ikke servicegebyr, medmindre dette er slået til.',
  no_fee: 'Din restaurant opkræver ingen servicegebyr, så bordbestillinger betaler heller ikke noget.',
  partner_default_on: 'Partnerstandard: til',
  partner_default_off: 'Partnerstandard: fra',
  toasts: {
    on: 'Bordbestillinger betaler nu servicegebyr',
    off: 'Bordbestillinger betaler nu ikke servicegebyr',
    error: 'Det blev ikke gemt. Prøv igen.',
  },
};
